import { useEffect, useState } from "react";
import { Building2, Loader2 } from "lucide-react";
import { api } from "@/lib/leuteliaApi";

const euro = (n) => (n == null ? "—" : `${n.toLocaleString("it-IT")} €`);
const data = (s) => (s ? new Date(s).toLocaleDateString("it-IT", { day: "numeric", month: "short", year: "numeric" }) : "—");
const STATO = { done: "Completa", running: "In corso", partial: "Parziale", error: "Errore", interrupted: "Interrotta", idle: "Mai avviata" };

export default function Gruppo({ scope, onSelectHotel }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (!scope?.tenant) return;
    api.gruppo(scope.tenant).then(setD).catch((e) => setErr(e.message));
  }, [scope?.tenant]);
  if (err) return <div className="px-8 py-7 text-[13px] text-brand-maroon" data-testid="gruppo-errore">{err}</div>;
  if (!d) return <div className="flex items-center gap-2 px-8 py-7 text-brand-muted"><Loader2 size={14} className="animate-spin" /> lettura del gruppo…</div>;
  return (
    <div className="relative z-10 px-4 sm:px-8 py-7 max-w-[1320px] leu-in" data-testid="pagina-gruppo">
      <div className="text-brand-orange font-bold tracking-[0.22em] text-[11px] uppercase mb-3">Gruppo</div>
      <h1 className="font-serif text-3xl md:text-4xl text-brand-ink">Le vostre strutture</h1>
      <p className="mt-2 text-[14px] text-brand-ink/70 max-w-3xl leading-relaxed">Pacchetto {d.package}. Ogni hotel ha le proprie scansioni mensili: non si trasferiscono fra strutture e si rinnovano ogni mese. La consultazione delle analisi è sempre libera.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-3">
        {[["Hotel", d.hotels.length], ["Scansioni comprese al mese", d.scans_total], ["Scansioni ancora disponibili", d.remaining_total]].map(([l, v]) => (
          <div key={l} className="rounded-xl border border-brand-gold/25 bg-white px-5 py-4"><div className="text-[11px] uppercase tracking-[0.16em] text-brand-ink/50">{l}</div><div className="font-serif text-[30px] text-brand-ink leading-none mt-1">{v}</div></div>
        ))}
      </div>
      <div className="mt-5 bg-white rounded-xl border border-brand-gold/25 p-5 overflow-x-auto">
        <div className="flex items-center gap-2 mb-3"><Building2 size={18} className="text-brand-gold" /><h3 className="font-serif text-[20px] text-brand-ink">Hotel del gruppo</h3></div>
        <table className="w-full min-w-[820px] text-[12.5px]" data-testid="gruppo-tabella">
          <thead><tr className="text-left text-[11px] uppercase tracking-[0.16em] text-brand-ink/50">
            <th className="pb-2">Struttura</th><th className="pb-2">Pacchetto</th><th className="pb-2">Scansioni/mese</th><th className="pb-2">Disponibili</th><th className="pb-2">Rinnovo</th><th className="pb-2">Ultima analisi</th><th className="pb-2">Stato</th><th className="pb-2 text-right">Canone mensile</th>
          </tr></thead>
          <tbody>
            {d.hotels.map((h) => (
              <tr key={h.hotel} className="border-t border-brand-gold/15" data-testid={`gruppo-riga-${h.hotel}`}>
                <td className="py-2.5 font-semibold text-brand-ink">{onSelectHotel ? <button onClick={() => onSelectHotel(h.hotel)} className="hover:underline text-left" data-testid={`gruppo-apri-${h.hotel}`}>{h.name}</button> : h.name}</td>
                <td>{h.package}</td><td>{h.included}</td>
                <td className={h.remaining === 0 ? "text-brand-maroon font-semibold" : ""}>{h.remaining}/{h.included}</td>
                <td>{data(h.cycle_end)}</td><td>{data(h.last_analysis_at)}</td><td>{STATO[h.analysis_status] || h.analysis_status}</td>
                <td className="text-right font-semibold">{euro(h.monthly_cost)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr className="border-t border-brand-gold/30"><td colSpan={7} className="pt-2.5 text-right text-brand-ink/70">Totale mensile del gruppo (IVA esclusa)</td><td className="pt-2.5 text-right font-serif text-[18px]" data-testid="gruppo-totale">{euro(d.monthly_total)}</td></tr></tfoot>
        </table>
      </div>
    </div>
  );
}
